import { createValidatedField } from '@/ui/pages/formPage/formUtils/createValidatedField';
import { Button, ButtonProps } from '@payaca/ambrosia';
import CollapsiblePanel, {
  CollapsiblePanelStyleVariant,
} from '@payaca/components/collapsiblePanel/CollapsiblePanel';
import { FormElement } from '@payaca/types/formElementTypes';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useMemo, useState } from 'react';

interface Props {
  elem: FormElement;
  formState: any;
  changeHandler: any;
  onFieldTouch: any;
  touchedState: any;
  validationState: any;
  uiHandlers: any;
}

export const MultiItemFormElement: FC<Props> = ({
  elem,
  formState,
  changeHandler,
  onFieldTouch,
  touchedState,
  validationState,
  uiHandlers,
}) => {
  const [selectedMultiItemIndex, setSelectedMultiItemIndex] = useState<
    number | undefined
  >(0);

  const items = useMemo(() => {
    return formState?.[elem.id] || [];
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'elem.id'
  }, [formState]);

  const addButtonProps: ButtonProps =
    items.length === 0 ? {} : { variant: 'link', linkColour: 'blue' };

  return (
    <div className={'form-multi-item-wrapper'}>
      <div className={'form-multi-item-wrapper-header'}>
        {elem.icon ? (
          <UntitledIcon name={elem.icon || 'edit-02.3'} className="w-6 h-6" />
        ) : (
          <UntitledIcon name="edit-05.3" />
        )}
        <h4>{elem.title}</h4>
      </div>
      <p>
        {`You can add as many items as you require by pressing the ${
          items.length === 0
            ? 'button below'
            : 'link at the bottom of your items'
        }`}
        .
      </p>
      {items.map((a: any, b: any) => (
        <CollapsiblePanel
          key={b}
          onOpen={() => {
            window.scrollTo(0, 300 + b * 60);
            setSelectedMultiItemIndex(b);
          }}
          onClose={() => setSelectedMultiItemIndex(-1)}
          title={`${elem?.itemNoun || elem?.title || 'Section'} #${b + 1}`}
          isOpen={b === selectedMultiItemIndex}
          styleVariant={CollapsiblePanelStyleVariant.OUTSIZE}
        >
          <div className={'multi-item-container'}>
            <div className={'remove-item'}>
              <Button
                variant="link"
                onClick={() => {
                  setSelectedMultiItemIndex(-1);
                  changeHandler({
                    [elem.id]: [
                      ...formState[elem.id].filter(
                        (item: any, i: number) => i !== b
                      ),
                    ],
                  });
                }}
              >
                Remove this item
              </Button>
            </div>
            <div>
              {elem.children &&
                elem.children.map((childElem: FormElement, ind: number) => (
                  <div key={ind}>
                    {createValidatedField(
                      childElem,
                      formState,
                      formState?.[elem.id]?.[b]?.[childElem.id] || '',
                      changeHandler,
                      onFieldTouch,
                      touchedState,
                      validationState,
                      uiHandlers,
                      ind,
                      `${elem.id}.${b}.${childElem.id}`
                    )}
                  </div>
                ))}
            </div>
          </div>
        </CollapsiblePanel>
      ))}
      <div className={'flex space-x-3.5'}>
        <Button
          onClick={() =>
            changeHandler({
              [elem.id]: [...(formState?.[elem.id] || []), {}],
            })
          }
          {...addButtonProps}
        >
          {items.length === 0 ? 'Add new' : 'Add additional'}
        </Button>
      </div>
    </div>
  );
};
